var _path, _path2, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Calque_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      "enableBackground": "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.4,24.7c2.1-2.2,8.8-7,17.6-7s15.5,4.8,17.6,7c1.1,1.1,2.8,1.2,4,0.1c1.1-1,1.2-2.8,0.1-3.9 c-2.9-3-11-8.7-21.7-8.7c-10.7,0-18.8,5.7-21.7,8.7c-1.1,1.1-1,2.9,0.1,3.9C9.5,25.9,11.3,25.9,12.4,24.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,33.2c1.6-1.4,4.6-3.9,9.4-3.9c4.7,0,7.8,2.5,9.4,3.9c1.1,1,2.9,0.9,4-0.2c1-1.1,1-2.9-0.2-3.9 c-1.9-1.7-6.2-5.3-13.1-5.3s-11.3,3.7-13.1,5.3c-1.1,1-1.2,2.8-0.2,3.9C17.8,34.1,19.6,34.2,20.7,33.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 30,
    cy: 42.2,
    rx: 5.7,
    ry: 5.6
  })));
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS40LjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FscXVlXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgNjAgNjAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDYwIDYwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojNDI4RUUwO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMTIuNCwyNC43YzIuMS0yLjIsOC44LTcsMTcuNi03czE1LjUsNC44LDE3LjYsN2MxLjEsMS4xLDIuOCwxLjIsNCwwLjFjMS4xLTEsMS4yLTIuOCwwLjEtMy45DQoJYy0yLjktMy0xMS04LjctMjEuNy04LjdjLTEwLjcsMC0xOC44LDUuNy0yMS43LDguN2MtMS4xLDEuMS0xLDIuOSwwLjEsMy45QzkuNSwyNS45LDExLjMsMjUuOSwxMi40LDI0Ljd6Ii8+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjAuNywzMy4yYzEuNi0xLjQsNC42LTMuOSw5LjQtMy45YzQuNywwLDcuOCwyLjUsOS40LDMuOWMxLjEsMSwyLjksMC45LDQtMC4yYzEtMS4xLDEtMi45LTAuMi0zLjkNCgljLTEuOS0xLjctNi4yLTUuMy0xMy4xLTUuM3MtMTEuMywzLjctMTMuMSw1LjNjLTEuMSwxLTEuMiwyLjgtMC4yLDMuOUMxNy44LDM0LjEsMTkuNiwzNC4yLDIwLjcsMzMuMnoiLz4NCjxlbGxpcHNlIGNsYXNzPSJzdDAiIGN4PSIzMCIgY3k9IjQyLjIiIHJ4PSI1LjciIHJ5PSI1LjYiLz4NCjwvc3ZnPg0K";
export { SvgComponent as ReactComponent };